import { useState } from 'react';
import "./Research.scss";
import NICASLogo from "../../assets/Research/Logo.png";
import About from './About/About';
import Editorial from './Editorial/Editorial.jsx';
import Authors from './Authors/Authors';
import { RiInformationLine } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { FaRegAddressBook } from "react-icons/fa";


const Research = () => {

    const [toggleFormPage, setToggleFormPage] = useState("About");

    return (
        <section className="researchPageMainContainer">
            <header>
                <h2 style={{color:"#116c4a"}}>Research</h2>
            </header>
            <article>
                {/* First Row */}
                <header>
                    {/* Logo & Title */}
                    <div className="firstRow">
                        <div className="logoParent">
                            <img src={NICASLogo} alt="Logo Of NICAS" />
                        </div>
                        <div className="titleParent">
                            <h2>NICAS JOURNAL OF SCIENCE & HUMANITIES</h2>
                            <h4>An Open Access, Peer-Reviewed, Journal</h4>
                        </div>
                        <div className="estbYearParent">
                            <h2>ESTD Year : 2025</h2>
                        </div>
                    </div>

                    {/* Navigation */}
                    <nav className="secondRow">
                        <div>
                            <button className={toggleFormPage === "About" ? "activeTab" : ""} onClick={() => setToggleFormPage("About")}>
                                <RiInformationLine  className="icon" /> <span>About</span>
                            </button>
                        </div>
                        <div>
                            <button className={toggleFormPage === "Editorial" ? "activeTab" : ""} onClick={() => setToggleFormPage("Editorial")}>
                                <FaRegEdit  className="icon" />  <span>Editorial</span>
                            </button>
                        </div>
                        <div>
                            <button className={toggleFormPage === "Authors" ? "activeTab" : ""} onClick={() => setToggleFormPage("Authors")}>
                                <FaRegAddressBook  className="icon" />  <span>Authors</span>
                            </button>
                        </div>
                    </nav>
                </header>

                {/* Second Row */}
                <main>
                    {toggleFormPage === "About" ?
                        (<About />)
                        : toggleFormPage === "Editorial" ?
                            (<Editorial />) :
                            (<Authors />)
                    }
                </main>
            </article>
        </section>
    )
}

export default Research
